const text = {
	variants: {
		link: {
			fontSize: {
				base: '16px',
				sm: '17px',
				md: '18px',
			},
			fontWeight: 'bold',
			fontFamily: 'Inter',
		},
		info: {
			fontSize: {
				base: '10px',
				sm: '12px',
				md: '14px',
			},
			fontWeight: 'extra-light',
			fontFamily: 'Inter',
		},
		p: {
			fontSize: {
				base: '16px',
				sm: '17px',
				md: '18px',
			},
			fontWeight: 'light',
			fontFamily: 'Inter',
		},
		h6: {
			fontSize: {
				base: '18px',
				sm: '20px',
				md: '22px',
				lg: '24px',
			},
			fontWeight: 'semi-bold',
			fontFamily: 'Inter',
		},
		h5: {
			fontSize: {
				base: '20px',
				sm: '24px',
				md: '28px',
				lg: '32px',
			},
			fontWeight: 'semi-bold',
			fontFamily: 'Inter',
		},
		h4: {
			fontSize: {
				base: '22px',
				sm: '28px',
				md: '34px',
				lg: '40px',
			},
			fontWeight: 'semi-bold',
			fontFamily: 'Inter',
		},
		h3: {
			fontSize: {
				base: '32px',
				sm: '40px',
				md: '48px',
				lg: '56px',
			},
			fontWeight: 'bold',
			fontFamily: 'Inter',
		},
		h2: {
			fontSize: {
				base: '40px',
				sm: '48px',
				md: '56px',
				lg: '64px',
			},
			fontWeight: 'extra-bold',
			fontFamily: 'Inter',
		},
		h1: {
			fontSize: {
				base: '56px',
				sm: '64px',
				md: '72px',
				lg: '80px',
			},
			fontWeight: 'black',
			fontFamily: 'Inter',
		},
	},
};

export default text;
